import router from "@/router";
import { api } from "@/services/api.service";
import { type HttpClient, type RequestOptions } from "@shopexperts/shared"
import axios, { type AxiosInstance } from "axios"

export class ApiClient implements HttpClient {
    private readonly axiosInstance: AxiosInstance

    constructor() {
        this.axiosInstance = axios.create({
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            },
        })
        this.axiosInstance.interceptors.request.use(config => {
            if (api.defaults.headers.common['Authorization']) {
                config.headers.Authorization = api.defaults.headers.common['Authorization'];
            }
            return config;
        });
        this.axiosInstance.interceptors.response.use(response => {
            return response;
        }, error => {
            // Don't redirect on 401 for public auth endpoints (login/register)
            // These endpoints return 401 for invalid credentials, which should be handled locally
            const isPublicAuthEndpoint = error.config?.url?.includes('/auth/login') || 
                                       error.config?.url?.includes('/auth/register');
            
            if (error.response?.status === 401 && !isPublicAuthEndpoint) {
                router.push('/logout');
            }
            return Promise.reject(error);
        });
    }

    async get<T>(url: string, opts?: RequestOptions): Promise<T> {
        return this.axiosInstance.get(url, { ...opts });
    }

    async post<T, D = unknown>(url: string, data: D, opts?: RequestOptions): Promise<T> {
        return this.axiosInstance.post(url, data, { ...opts });
    }

    async put<T, D = unknown>(url: string, data: D, opts?: RequestOptions): Promise<T> {
        return this.axiosInstance.put(url, data, { ...opts });
    }

    async patch<T, D = unknown>(url: string, data: D, opts?: RequestOptions): Promise<T> {
        return this.axiosInstance.patch(url, data, { ...opts });
    }

    async delete<T, D = unknown>(url: string, data?: D, opts?: RequestOptions): Promise<T> {
        return this.axiosInstance.delete(url, { data, ...opts });
    }
}


